import React from 'react';
import Styled from 'styled';
import { useQuery } from '@apollo/client/react/hooks';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';

import query, { ForumWidgetQuery, ForumWidgetQueryVariables } from './forum-widget.graphql';
import defaultStyles from './forum-widget.scss';

interface Props {
    styles: typeof defaultStyles;
    categoryIds: string[];
}

const ForumWidget: React.FC<Props> = props => {
    const { styles, categoryIds } = props;

    const { data } = useQuery<ForumWidgetQuery, ForumWidgetQueryVariables>(query, { variables: { categoryIds } });

    if (data && data.threads && data.threads.edges && data.threads.edges.length) {
        return (
            <div className={styles.widget}>
                <div className={styles.widgetTitle}>
                    <FormattedMessage id='DISCUSSION_ON_THIS_TOPIC' />
                </div>
                <div className={styles.threads}>
                    <ul className={styles.list}>
                        {data.threads.edges.slice(0, Math.round(data.threads.edges.length / 2)).map(edge =>
                            edge && edge.node ? (
                                <li className={styles.item}>
                                    <Link to={edge.node.href as string} className={styles.link}>
                                        <TextShortener text={edge.node.title} textLength={40} />
                                    </Link>
                                </li>
                            ) : null
                        )}
                    </ul>
                    <ul className={styles.list}>
                        {data.threads.edges.slice(Math.round(data.threads.edges.length / 2)).map(edge =>
                            edge && edge.node ? (
                                <li className={styles.item}>
                                    <Link to={edge.node.href as string} className={styles.link}>
                                        <TextShortener text={edge.node.title} textLength={40} />
                                    </Link>
                                </li>
                            ) : null
                        )}
                    </ul>
                </div>
            </div>
        );
    }
    return null;
};

export default Styled(defaultStyles)(ForumWidget);
